const newEmptyState = () => ({
  active: false,
  icon: null,
  iconColor: null,
  title: null,
  text: null,
  textMultiple: [],
  textVariables: [],
});

export default {
  namespaced: true,
  actions: {
    async CREATE({ commit, dispatch }, {
      icon,
      iconColor = null,
      title,
      text,
      textMultiple,
      textVariables,
    }) {
      commit('UPDATE_DIALOG', {
        active: true,
        icon,
        iconColor,
        title,
        text,
        textMultiple,
        textVariables,
      });
    },
    CLOSE({ commit }) {
      commit('UPDATE_DIALOG', newEmptyState());
    },
  },
  mutations: {
    UPDATE_DIALOG(state, {
      active, icon, iconColor, title, text, textMultiple = [], textVariables = [],
    }) {
      state.active = active;
      state.icon = icon;
      state.iconColor = iconColor;
      state.title = title;
      state.text = text;
      state.textMultiple = textMultiple;
      state.textVariables = textVariables;
    },
  },
  state() {
    return newEmptyState();
  },
};
